export function hasPermission(permission) {
  const stored = sessionStorage.getItem("rolepermissions");
  if (!stored) return false;
  const roles = JSON.parse(stored);
  if (!Array.isArray(roles) || roles.length === 0) return false;
  return roles.some(
    (role) => Array.isArray(role.permissions) && role.permissions.includes(permission.toLowerCase())
  );
}
